import React, { FC } from "react";
import SubscriptionSelect from "@components/SubscriptionSelect";
import OnboardingForm from "@components/Onboarding/OnboardingForm/OnboardingForm";
import PaymentIcon from "@mui/icons-material/Payment";
import { OnboardingFormContainer } from "@components/Onboarding/OnboardingForm";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";

const OnboardingBilling: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack padding="16px" alignItems="center">
      <OnboardingForm
        title={t("onboardingBilling.title")}
        subtitle={t("onboardingBilling.subtitle")}
        icon={<PaymentIcon fontSize="small" />}
      >
        <OnboardingFormContainer>
          <SubscriptionSelect
            onSubscribed={() => navigate("/onboarding/success")}
            onContinue={() => navigate("/onboarding/success")}
            isOnboarding={true}
          />
        </OnboardingFormContainer>
      </OnboardingForm>
    </Stack>
  );
};

export default OnboardingBilling;
